var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8432 20.3114V15.6238C14.8432 15.4166 14.7609 15.2179 14.6144 15.0714C14.4678 14.9249 14.2691 14.8426 14.0619 14.8426H10.9369C10.7297 14.8426 10.531 14.9249 10.3845 15.0714C10.238 15.2179 10.1557 15.4166 10.1557 15.6238V20.3114C10.1557 20.5186 10.0734 20.7173 9.92689 20.8638C9.7804 21.0103 9.58171 21.0926 9.37453 21.0927L4.6876 21.0933C4.58499 21.0933 4.48339 21.0731 4.3886 21.0338C4.2938 20.9946 4.20766 20.937 4.13511 20.8645C4.06255 20.7919 4.005 20.7058 3.96573 20.611C3.92646 20.5162 3.90625 20.4146 3.90625 20.312V11.2827C3.90625 11.1738 3.92899 11.0662 3.97302 10.9667C4.01705 10.8671 4.08139 10.7779 4.16192 10.7047L11.9739 3.60165C12.1177 3.4709 12.3051 3.39844 12.4994 3.39844C12.6938 3.39843 12.8812 3.47087 13.025 3.60162L20.838 10.7047C20.9186 10.7779 20.9829 10.8671 21.027 10.9667C21.071 11.0662 21.0938 11.1739 21.0938 11.2827V20.312C21.0938 20.4146 21.0735 20.5162 21.0343 20.611C20.995 20.7058 20.9374 20.7919 20.8649 20.8645C20.7923 20.937 20.7062 20.9946 20.6114 21.0338C20.5166 21.0731 20.415 21.0933 20.3124 21.0933L15.6243 21.0927C15.4171 21.0926 15.2185 21.0103 15.072 20.8638C14.9255 20.7173 14.8432 20.5186 14.8432 20.3114V20.3114Z",
    stroke: "#4F7D9C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.9622b5e68fc73e747e9f24c647583de2.svg";
export { ForwardRef as ReactComponent };